$('#thumbs a').on('click', function(e){
  e.preventDefault();
  $('#thumbs a').removeClass('active');
  $('#main-image img').attr('src',$(this).attr('href'));
  $(this).addClass('active');
});